"use strict";

var _classCallCheck = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

var _Object$getOwnPropertyDescriptor2 = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.noWrapList = exports.weightList = exports.transformList = exports.gutterList = exports.colorList = exports.alignmentList = exports.defaultHeadlineMapping = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactJss = require("react-jss");

var _classnames = _interopRequireDefault(require("classnames"));

var _Typography = _interopRequireDefault(require("./Typography.styles"));

var _class, _class2, _temp;

function _getRequireWildcardCache() {
  if (typeof _WeakMap !== "function") return null;
  var cache = new _WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = _Object$defineProperty2 && _Object$getOwnPropertyDescriptor2;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor2(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        _Object$defineProperty2(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = _assign["default"] || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = (0, _keys["default"])(object);

  if (_getOwnPropertySymbols["default"]) {
    var symbols = (0, _getOwnPropertySymbols["default"])(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_getOwnPropertyDescriptors["default"]) {
      (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2["default"])(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (_getOwnPropertySymbols["default"]) {
    var sourceSymbolKeys = (0, _getOwnPropertySymbols["default"])(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = (0, _keys["default"])(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var oneOfKey = function oneOfKey(target) {
  return (0, _propTypes.oneOf)((0, _keys["default"])(target));
};

var defaultHeadlineMapping = {
  mainHeading: 'h2',
  sectionHeading: 'h2',
  sectionTitleLg: 'h3',
  sectionTitleMd: 'h3',
  sectionTitleSm: 'h3',
  callOutLg: 'div',
  callOutMd: 'div',
  callOutSm: 'div',
  textLg: 'p',
  text: 'p',
  textMd: 'p',
  textSm: 'p'
};
exports.defaultHeadlineMapping = defaultHeadlineMapping;
var alignmentList = ['', 'left', 'center', 'right', 'justify'];
exports.alignmentList = alignmentList;
var colorList = ['', 'inherit', 'background', 'cover', 'primary', 'primaryContrast', 'secondary', 'secondaryContrast'];
exports.colorList = colorList;
var gutterList = [0, 2, 4, 8, 16, 24, 32];
exports.gutterList = gutterList;
var transformList = ['none', 'uppercase', 'lowercase', 'capitalize', 'full-width'];
exports.transformList = transformList;
var weightList = ['', 'normal', 'light', 'semibold', 'bold'];
exports.weightList = weightList;
var noWrapList = [false, true, 1, 2];
exports.noWrapList = noWrapList;

var Typography = (0, _Typography["default"])(_class = (0, _reactJss.withTheme)(_class = (_temp = _class2 =
/*#__PURE__*/
function (_react$Component) {
  _inherits(Typography, _react$Component);

  function Typography() {
    _classCallCheck(this, Typography);

    return _possibleConstructorReturn(this, _getPrototypeOf(Typography).apply(this, arguments));
  }

  _createClass(Typography, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          style = _this$props.style,
          type = _this$props.type,
          align = _this$props.align,
          color = _this$props.color,
          gutter = _this$props.gutter,
          transform = _this$props.transform,
          weight = _this$props.weight,
          italic = _this$props.italic,
          headlineMapping = _this$props.headlineMapping,
          lineClamp = _this$props.lineClamp,
          noWrap = _this$props.noWrap,
          highlight = _this$props.highlight,
          fullWidth = _this$props.fullWidth,
          paragraph = _this$props.paragraph,
          tag = _this$props.tag,
          genClass = _this$props.theme.genClass,
          props = _objectWithoutProperties(_this$props, ["classes", "className", "style", "type", "align", "color", "gutter", "transform", "weight", "italic", "headlineMapping", "lineClamp", "noWrap", "highlight", "fullWidth", "paragraph", "tag", "theme"]);

      if (!props.children && !props.dangerouslySetInnerHTML) {
        return null;
      }

      var finalStyle = _objectSpread({}, style);

      var finalClassName = (0, _classnames["default"])(classes.base, classes[genClass('type', type)], classes[genClass('color', color)], classes[genClass('gutter', gutter)], classes[genClass('typeModifier', weight, transform, italic && 'italic')], classes[genClass('transform', transform)], classes[genClass('weight', weight)], classes[genClass('align', align)], classes[genClass('style', italic && 'italic')], classes[genClass('style', highlight && 'highlight')], classes[genClass('style', fullWidth && 'fullWidth')], noWrap && classes.noWrap, lineClamp && classes.lineClamp, className);

      if (lineClamp) {
        finalStyle.WebkitLineClamp = lineClamp;
      }

      var Component = tag || paragraph && 'p' || headlineMapping[type] || 'span';
      return _react["default"].createElement(Component, _extends({
        style: finalStyle,
        className: finalClassName
      }, props));
    }
  }]);

  return Typography;
}(_react.Component), _class2.propTypes = {
  type: oneOfKey(defaultHeadlineMapping),
  align: (0, _propTypes.oneOf)(alignmentList),
  color: (0, _propTypes.oneOf)(colorList),
  gutter: (0, _propTypes.oneOf)(gutterList),
  noWrap: _propTypes.bool,
  lineClamp: _propTypes.number,
  paragraph: _propTypes.bool,
  transform: (0, _propTypes.oneOf)(transformList),
  weight: (0, _propTypes.oneOf)(weightList),
  italic: _propTypes.bool,
  highlight: _propTypes.bool,
  fullWidth: _propTypes.bool,
  tag: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func]),
  headlineMapping: _propTypes.object
}, _class2.defaultProps = {
  style: {},
  type: 'text',
  color: 'inherit',
  align: '',
  gutter: 0,
  headlineMapping: defaultHeadlineMapping,
  noWrap: false,
  paragraph: false,
  transform: 'none',
  weight: ''
}, _temp)) || _class) || _class;

exports["default"] = Typography;